module.exports = __webpack_public_path__ + "img/out.58b9a781.svg";